import type { Dealer } from './useAuth'
import { useAuth } from './useAuth'



export function usePermissions() {


    const { userData } = useAuth()
    const dealers = computed<Dealer[]>(() => userData.value?.dealers || [])


    /**
     * Checks if the dealer has a specific permission.
     *
     * @param permission - The permission string to check (e.g., "read:orders").
     * @returns true if the dealer has the permission, false otherwise.
     */
    function hasPermission(permission: string): boolean {
        return dealers.value.some((dealer) => dealer.permissions.includes(permission));
    }

    /**
     * Checks if the dealer has at least one permission from the provided list.
     *
     * @param permissions - An array of permission strings.
     * @returns true if the dealer has any one of the permissions, false otherwise.
     */
    function hasAnyPermission(permissions: string[]): boolean {
        return permissions.some((perm) => dealers.value.some((dealer) => dealer.permissions.includes(perm)));
    }

    /**
     * Checks if the dealer has all of the permissions provided.
     *
     * @param permissions - An array of permission strings.
     * @returns true if the dealer has all of the permissions, false otherwise.
     */
    function hasAllPermissions(permissions: string[]): boolean {
        return permissions.every((perm) => dealers.value.some((dealer) => dealer.permissions.includes(perm)));
    }

    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
    };
}